import React, { useEffect } from "react";
import { useRequest } from "ahooks";
import ReactEcharts from "echarts-for-react";

function WeatherChart({ lng, lat, date }) {
  const { data, run } = useRequest(
    (date, lng, lat) =>
      `/api/data/temperature?date=${date}&lng=${lng}&lat=${lat}&type=present`,
    { manual: true }
  );

  useEffect(() => {
    run(date, lng, lat);
  }, [run, date, lng, lat]);

  let dates = [],
    value = [];
  if (data && data.status === "OK") {
    dates = data.msg.map((t) => t.date);
    value = data.msg.map((t) => t.temperature);
  }

  return (
    <ReactEcharts
      option={{
        xAxis: {
          type: "category",
          data: dates,
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: 12,
            lineHeight: 16,
            end: true,
            margin: 10,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: 12,
            lineHeight: 16,
            end: true,
            margin: 10,
            formatter: "{value} °C",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.35)",
            },
          },
        },
        series: [
          {
            data: value,
            type: "line",
          },
        ],
        color: "#ffc53d",
        grid: {
          left: "50",
          right: "10",
          bottom: "30",
          top: "10",
        },
        tooltip: {
          show: true,
        },
      }}
      style={{ height: "100%", width: "100%" }}
    />
  );
}

export default WeatherChart;
